// Token format produced by maskPlaceholders.
// eslint-disable-next-line no-control-regex -- NUL is the point: it cannot occur in the data
const MASK_PATTERN = /\u0000(\d+)\u0000/g;

// Restores the {{ }} placeholders masked by maskPlaceholders.
export const unmaskPlaceholders = (
  masked: string,
  placeholders: string[]
): string =>
  masked.replace(MASK_PATTERN, (_, index) => placeholders[Number(index)]);
